import axios from 'axios';
import { Message } from 'element-ui';
import router from '@/router';

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8';

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API || '/api',
  timeout: 10000
});

service.interceptors.request.use(
  config => {
    const token = localStorage.getItem('MIAOBI_TOKEN');

    if (token) {
      config.headers['satoken'] = token;
    }
    if (config.method === 'get' && config.params) {
      config.params = Object.assign({ _t: Date.now() }, config.params);
    }
    return config;
  },
  error => Promise.reject(error)
);

service.interceptors.response.use(
  response => {
    const res = response.data || {};
    const code = res.code !== undefined ? res.code : 200;
    if (code !== 200) {
      const msg = res.msg || '请求失败';
      Message.error(msg);
      return Promise.reject(new Error(msg));
    }
    return res;
  },
  error => {
    const status = error.response && error.response.status;
    if (status === 401) {
      localStorage.removeItem('MIAOBI_TOKEN');
      Message.error('登录已过期，请重新登录');
      router.replace({ name: 'Login', query: { redirect: router.currentRoute.fullPath } });
      return Promise.reject(error);
    }
    const msg =
      (error.response && error.response.data && error.response.data.msg) ||
      error.message ||
      '网络异常';
    Message.error(msg);
    return Promise.reject(error);
  }
);

export default service;
